import { useMutation } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import { AxiosResponseAndError,ResponseType } from "@/api/types/axiosResponseType";
import ApiRequest from "../ApiRequest";

type TaskDuplicateResponseType = ResponseType<null>;
function useTaskDuplicateMutation() {

  const mutation = useMutation<
    AxiosResponseAndError<TaskDuplicateResponseType>["response"],
    AxiosResponseAndError<TaskDuplicateResponseType>["error"],
    string
  >({
    mutationFn: (data) =>
      ApiRequest.put<TaskDuplicateResponseType>(
        `${requestURLs.task}duplicate-task/${data}`,
        data
      ),
  });

  return mutation;
}
export default useTaskDuplicateMutation;
